import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, useMediaQuery, Typography, Grid, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonView } from '../../../components/Button';
import { InputLabel } from '../../../../home/Home-components';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps3 {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps3) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export const ApprovalDialog = (props: any) => {    

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const submitApproval=()=>{
       // submit approval
    }

    return (
        <div>
            <BootstrapDialog
                onClose={props.onClose}
                aria-labelledby={props.labelledby}
                open={props.open}
                fullScreen={fullScreen}
                fullWidth={true}
                sx={{ padding: 10 }}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
                    Approval Dialog Box
                </BootstrapDialogTitle>
                <DialogContent dividers style={{ padding: 40 }}>
                    <Grid container spacing={3} style={{ paddingTop: 20 }}>
                        <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                            <InputLabel>
                                <Typography variant="subtitle1" gutterBottom>
                                    Comments
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                            <Stack spacing={2} sx={{ width: '30ch', paddingLeft: 1 }}>
                                <TextField
                                    id="outlined-textarea"
                                    label=""
                                    placeholder=""
                                    rows={4}
                                    multiline
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonView variant="contained" name='Notify User' color="primary" type='submit' onClick={submitApproval} />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
